import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import theme from 'live/services/theme'
import LiveTooltip from 'live/components/ui/tooltip'
import PipesInputFactory from 'live/components/events/ui/console-input'

const PipesInput = PipesInputFactory()

type EditQueryProps = {
    code: string
    setCode: Function
    defaultQuery: string
}

function EditQuery(props: EditQueryProps) {
    const { code, setCode, defaultQuery } = props

    const _onChange = (newCode: string) => {
        setCode(newCode)
    }

    const useDefaultQuery = () => {
        setCode(defaultQuery)
    }

    const isDefaultQuery = code === defaultQuery

    return (
        <Container>
            <Header>
                <Title>
                    <div>{i18n('EXPRESSION (Pipes)')}</div>
                    <LiveTooltip position="top" content={i18n('Help with language.')}>
                        <a href="https://pipes.intelie.com/docs/0.24/" target="_blank">
                            <i className="fas fa-book" />
                        </a>
                    </LiveTooltip>
                </Title>
                <LiveTooltip
                    hide={!isDefaultQuery}
                    position="top"
                    content={i18n('You are already using the default query.')}
                >
                    <RestoreQuery isDefaultQuery={isDefaultQuery} onClick={useDefaultQuery}>
                        {i18n('RESTORE DEFAULT QUERY')}
                    </RestoreQuery>
                </LiveTooltip>
            </Header>
            <Footer>
                <PipesInput
                    expression={code}
                    lineNumbers={true}
                    onChangeExpression={_onChange}
                    disableFocus={true}
                    maxHeight={350}
                />
                <Msg>{i18n('Editing this query may cause chart malfunction.')}</Msg>
            </Footer>
        </Container>
    )
}

export default EditQuery

const Container = styled.div`
    max-height: 400px;
    display: flex;
    flex-direction: column;
    background: #fff;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
`

const Footer = styled.div`
    margin-top: 5px;
`

const Title = styled.div`
    display: flex;
    align-items: center;
    margin: 15px 0 0 24px;

    > div {
        margin-right: 8px;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        font-family: ${theme['font-semibold']};
        color: #364159;
    }

    > i {
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        color: #37a3ef;
    }
`

type RestoreQueryProps = { isDefaultQuery: boolean }
const RestoreQuery = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    background: transparent;
    display: block;
    border: none;
    font-family: ${theme['font-semibold']};
    margin: 15px 18px 0 0;
    cursor: ${({ isDefaultQuery }: RestoreQueryProps) => (isDefaultQuery ? 'default' : 'pointer')};
    color: ${({ isDefaultQuery }: RestoreQueryProps) => (isDefaultQuery ? '#C8CCD4' : '#37A3EF')};
`

const Msg = styled.div`
    height: 31px;
    background: #fafac3;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 24px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #364159;
    font-family: ${theme['font-regular']};
`
